import React, { useState } from "react";
import QRCode from "react-qr-code";

const dummyAppointments = [
  {
    id: "GAS-APT-001",
    agenda: "Vendor Discussion",
    date: "2025-01-10",
    venue: "Office HQ",
  },
  {
    id: "GAS-APT-002",
    agenda: "Investor Meeting",
    date: "2025-01-12",
    venue: "Conference Room",
  },
];

const GASEntryPass = () => {
  const [selected, setSelected] = useState(null);
  const [status, setStatus] = useState("Valid");
  const [scanLog, setScanLog] = useState(null);

  const handleScan = () => {
    const now = new Date().toLocaleString();
    setStatus("Used");
    setScanLog(now);
  };

  return (
    <div className="min-h-screen bg-black text-cyan-400 px-4 py-6">
      <h2 className="text-xl font-semibold mb-4">Entry Pass & QR</h2>

      {/* Appointment Selector */}
      <div className="mb-4">
        <label className="block text-xs mb-1">Select Appointment</label>
        <select
          className="w-full bg-black border border-cyan-700 rounded px-3 py-2 text-sm"
          onChange={(e) =>
            setSelected(
              dummyAppointments.find((a) => a.id === e.target.value)
            )
          }
        >
          <option value="">-- Select --</option>
          {dummyAppointments.map((apt) => (
            <option key={apt.id} value={apt.id}>
              {apt.id} | {apt.agenda}
            </option>
          ))}
        </select>
      </div>

      {/* QR Section */}
      {selected && (
        <div className="border border-cyan-700 rounded-xl p-4 text-center">
          <p className="text-sm mb-2">{selected.agenda}</p>
          <p className="text-xs text-gray-400 mb-3">
            {selected.date} • {selected.venue}
          </p>

          <div className="bg-white p-3 inline-block rounded">
            <QRCode
              value={JSON.stringify({
                appointmentId: selected.id,
                venue: selected.venue,
              })}
              size={180}
            />
          </div>

          {/* Status */}
          <div className="mt-4 text-sm">
            Status:{" "}
            <span
              className={`font-semibold ${
                status === "Valid"
                  ? "text-green-400"
                  : "text-yellow-400"
              }`}
            >
              {status}
            </span>
          </div>

          {/* Scan Simulation */}
          <button
            onClick={handleScan}
            disabled={status !== "Valid"}
            className="mt-4 px-4 py-2 bg-cyan-600 text-black rounded disabled:opacity-40"
          >
            Simulate Security Scan
          </button>

          {/* Scan Log */}
          {scanLog && (
            <div className="mt-4 text-xs text-gray-300">
              Scanned at: {scanLog}
            </div>
          )}
        </div>
      )}

      {/* Notes */}
      <div className="mt-6 text-xs text-gray-500">
        * QR is scanned at Security / Reception.  
        * Status changes after first successful scan.
      </div>
    </div>
  );
};

export default GASEntryPass;
